import React, { useCallback, useMemo } from 'react';
import YouTube, { YouTubeProps } from 'react-youtube';
import { isIOS } from 'react-device-detect';

import { IYoutubeEmbed } from '../interfaces';

import { iframeStyles, VideoBackground } from './style';

const YoutubeEmbed = ({ embedId }: IYoutubeEmbed) => {
  const opts: YouTubeProps['opts'] = useMemo(
    () => ({
      playerVars: {
        autoplay: 1,
        controls: 0,
        modestbranding: 1,
        rel: 0,
        mute: isIOS ? 1 : 0,
      },
      width: '100%',
      height: '100%',
    }),
    [],
  );

  const onPlayerReady = useCallback(async (event: any) => {
    if (isIOS) {
      document.addEventListener(
        'click',
        () => {
          event.target.unMute();
        },
        { once: true },
      );
    }
  }, []);

  return (
    <VideoBackground>
      <YouTube
        videoId={embedId}
        opts={opts}
        title="YouTube Video"
        onReady={onPlayerReady}
        style={iframeStyles}
      />
    </VideoBackground>
  );
};

export default YoutubeEmbed;
